import {paramsToUrl} from 'app/utils/url'

function doAction(apiUrl, method, params) {
    method = method.toLowerCase()
    apiUrl = method === 'get'
        ? paramsToUrl(apiUrl, params)
        : apiUrl

    return fetch(apiUrl, {
        method: method,
        credentials: "same-origin", // won't send cookies without this
        headers: method === 'get' ? undefined : new Headers({
            'Content-Type': 'application/json',
        }),
        body: method === 'get' ? undefined : JSON.stringify(params),
    })
    .then((response) => {
        return response.json()
            .then(data => {
                return {
                    statusCode: response.status,
                    data,
                }
            })
    })
}

function addSchool({
    apiUrl,
    schoolId,
}) {
    return doAction(apiUrl, 'post', {
        op: 'school/add',
        schoolId,
    })
}

function removeSchool({
    apiUrl,
    schoolId,
}) {
    return doAction(apiUrl, 'post', {
        op: 'school/remove',
        schoolId,
    })
}

function getSchools({
    apiUrl,
}) {
    return doAction(apiUrl, 'get', {
        op: 'school/list',
    })
}

function signup({
    apiUrl,
    name,
    email,
    password,
    isMailingList,
    isSignedUpForTargetedCommunication,
    isSignedUpToShareContactInformationBasedOnSavedSchools,
    isSignedUpToShareContactInformationBasedOnInterest,
}) {
    return doAction(apiUrl, 'post', {
        op: 'account/signup',
        name,
        email,
        password,
        isMailingList,
        isSignedUpForTargetedCommunication,
        isSignedUpToShareContactInformationBasedOnSavedSchools,
        isSignedUpToShareContactInformationBasedOnInterest,
    })
}

function logout({
    apiUrl,
}) {
    return doAction(apiUrl, 'post', {
        op: 'account/logout',
    })
}

function signin({
    apiUrl,
    email,
    password,
}) {
    return doAction(apiUrl, 'post', {
        op: 'account/login',
        email,
        password,
    })
}

function signinGoogle({
    apiUrl,
    token,
    isMailingList,
    isSignedUpForTargetedCommunication,
    isSignedUpToShareContactInformationBasedOnSavedSchools,
    isSignedUpToShareContactInformationBasedOnInterest,
}) {
    return doAction(apiUrl, 'post', {
        op: 'account/login-federated',
        provider: 'google',
        token,
        isMailingList,
        isSignedUpForTargetedCommunication,
        isSignedUpToShareContactInformationBasedOnSavedSchools,
        isSignedUpToShareContactInformationBasedOnInterest,
    })
}

function forgotPassword({
    apiUrl,
    email,
}) {
    return doAction(apiUrl, 'post', {
        op: 'account/forgot-password',
        email,
    })
}

function resendVerify({
    apiUrl,
    email,
}) {
    return doAction(apiUrl, 'post', {
        op: 'account/resend-verify',
        email,
    })
}

function savePreferences({
    apiUrl,
    name,
    email,
    isMailingList,
    isSignedUpForTargetedCommunication,
    isSignedUpToShareContactInformationBasedOnSavedSchools,
    isSignedUpToShareContactInformationBasedOnInterest,
    graduationYear,
    city,
    state,
    areasOfStudy,
    interestedStates,
    satScore,
    actScore,
}) {
    return doAction(apiUrl, 'post', {
        op: 'account/update-preferences',
        name,
        email,
        isMailingList,
        isSignedUpForTargetedCommunication,
        isSignedUpToShareContactInformationBasedOnSavedSchools,
        isSignedUpToShareContactInformationBasedOnInterest,
        graduationYear,
        city,
        state,
        areasOfStudy,
        interestedStates,
        satScore,
        actScore,
    })
}

function changePassword({
    apiUrl,
    currentPassword,
    password,
}) {
    return doAction(apiUrl, 'post', {
        op: 'account/change-password',
        currentPassword,
        password,
    })
}

function getIsLoggedIn({
    apiUrl,
}) {
    return doAction(apiUrl, 'get', {
        op: 'account/isLoggedIn',
    })
}

export default {
    addSchool,
    removeSchool,
    signup,
    signinGoogle,
    logout,
    signin,
    forgotPassword,
    resendVerify,
    savePreferences,
    changePassword,
    getSchools,
    getIsLoggedIn,
}



// WEBPACK FOOTER //
// ./react/my-schools/api/index.js